<template>
    <div class="caseitem-box">
        <div class="parent-box">
            <div class="box" v-for='(item,index) in caseitemData' :key='index'>
                <div class="imgbox" :style='{backgroundImage:"url("+item.imgurl+")"}'></div>
                <div class="titlebox">
                    <h5 class="caption">{{item.name}}</h5>
                    <p class="title">{{item.title}}</p>
                </div>
                <span class="job">{{item.job}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'CaseItem',
        data() {
            return {
                caseitemData: [
                    {
                        name: '家装行业',
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/db6fea11-d568-4c49-93c1-adbef14d7e5f.jpg',
                        title: '从2020年2月开始运营至2020年5月，三个月添加优质客户资源282个，发布帖子30片，收到客户询价约20个。',
                        job: '领英服务'
                    },
                    {
                        name: '阀门行业',
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/29e645db-15b0-4b8e-931f-c8792c1fda9f.jpg',
                        title: '从2020年3月签约，运营至2020年6月低，收到优质客户询盘18个，积累阀门行业LinkedIn好友数211个。每周约有150人查看个人主页，每周帖子搜索量170人次。',
                        job: '领英服务'
                    },
                    {
                        name: '家居行业',
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/%E7%BB%84%20771.jpg',
                        title: '从2019年12月至 2020年6月，帮助客户进行Facebook主页推广，共收获主页的自然粉丝点赞数9000个。每月收到50+人次客户咨询。',
                        job: 'Facebook服务'
                    }
                ]
            }
        }
    }
</script>
<style scoped>
    .caseitem-box {
        margin-bottom: 17.39vw;
    }

    .parent-box {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        width: 85.41%;
        margin: 0 auto;
        grid-column-gap: 16px;
    }

    .box {
        background-color: #ffffff;
        position: relative;
        border-bottom: 8px solid #F9F9F9;
    }

    .box::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 8px;
        width: 0%;
        transform: translateY(100%);
        background-color: #2488F8;
        transition: all 0.8s ease-in-out;
    }

    .box:hover::after {
        width: 100%;
    }

    .imgbox {
        height: 17.7vw;
        width: 100%;
        background: #666666 no-repeat center;
        background-size: cover;
    }

    .titlebox {
        min-height: 260px;
        padding: 51px 39px;
        display: flex;
        flex-direction: column;
        /* border-bottom: 8px solid #F9F9F9; */
        position: relative;
    }

    .box:hover .titlebox::after {
        width: 100%;
    }

    .job {
        position: absolute;
        bottom: 2%;
        right: 5%;
        font-size: 16px;
        font-weight: bold;
        line-height: 175%;
        margin-top: 45px;
        color: rgba(36, 136, 248, 1);
    }

    .caption {
        font-size: 24px;
        font-weight: 400;
        line-height: 116%;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 22px;
    }

    .title {
        font-size: 16px;
        font-weight: 400;
        line-height: 175%;
        color: rgba(153, 153, 153, 1);
    }

    @media(max-width: 995px) {
        .caseitem-box {
        margin-bottom:150px;
    }
        .parent-box {
            grid-template-columns: 1fr;
            grid-row-gap: 2%;
            width: 90%;
        }

        .imgbox {
            height: 55.2vw;
        }
        .title {
        font-size: 16px;
    }
    .titlebox {
        padding: 10% 5%;
    }
    }

    /* @media(max-width: 1023px){
        .parent-box {
        grid-template-columns:1fr;
        grid-row-gap: 2%;
        width: 1640px;
    }
    .imgbox{
        height: 1000px;
    }
    .caption {
        font-size: 75px;
        line-height: 110%;
    }

    .title {
        font-size: 50px;
        font-weight: 400;
        line-height: 150%;
    }
    .titlebox {
        height: auto;
        padding: 51px 39px;
        display: flex;
        flex-direction: column;
        border-bottom: 8px solid #F9F9F9;
        position: relative;
    }
    .job {
        font-size: 50px;
        line-height: 120%;
    }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/case/caseitem.vue